import managedWh from "./../Images/Warehouse/nonCertifiedWarehouse.png";
import certified from "./../Images/Warehouse/certifiedWarehouse.png";
import apmc from "./../Images/Warehouse/apmcMandi.png";
import railway from "./../Images/Warehouse/railwayStation.png";

export const mapIcons = [
  {
    image: certified,
    label: "Arya Certified",
  },
  {
    image: managedWh,
    label: "Non Certified",
  },
  {
    image: railway,
    label: "Railway Station",
  },
  {
    image: apmc,
    label: "APMC Mandi",
  },
];

export const bookWarehouseRules = () => {
  return [
    {
      field_name: "commodity",
      label: "Commodity",
      type: "string",
      isRequired: true,
    },
    {
      field_name: "start_date",
      label: "Start Date",
      type: "string",
      isRequired: true,
    },
    {
      field_name: "end_date",
      label: "End Date",
      type: "string",
      isRequired: true,
    },
    {
      field_name: "quantity",
      label: "Quantity",
      type: "number",
      isRequired: true,
      graterThen: 0,
    },
  ];
};

export const commonFilter = {
  "Arya Certified": ["Arya Certified", "Arya Listed"],
  "Booking Options": ["Full", "Partial"],
  "Warehouse Structure": ["RCC", "PEB", "Hybrid"],
  Amenities: ["Pakka Road", "Kacha Road"],
  "Seperate Guard Room": ["Yes"],
  "Brokerage Room": ["Yes"],
  "Warehouse License": [
    "Warehouse License",
    "FSSAI License",
    "WDRA License",
    "Storage License",
    "Procurement License",
  ],
  "Ancillary Services": [
    "Warehouse Management",
    "Finance",
    "Quality Testing",
    "Fumigation",
    "Monitoring",
    "Logistics and Handling",
    "Insurance",
    "Commodity Marketplace",
  ],
};
